import React from 'react';
import styled from 'styled-components';

import CommentList from '../../../../shared/comments/CommentList';
import LogList from '../../../../shared/log/LogList';
import CustomizeTab from '../../../../shared/tab/CustomizeTab';

const ActivitySectionContainer = styled.div`
  margin-top: 5rem;
`;

const Activities = ({ productId }: { productId: string }) => {
  const tabs = [
    {
      label: 'Comments',
      content: <CommentList modelName={'Product'} modelId={productId} />,
    },
    {
      label: 'History',
      content: <LogList modelName={'Product'} modelId={productId} />,
    },
  ];

  return (
    <ActivitySectionContainer>
      <CustomizeTab components={tabs} />
    </ActivitySectionContainer>
  );
};

export default Activities;
